<script setup>
import LayoutProfile from '../../Layouts/LayoutProfile.vue'
</script>

<template>
  <LayoutProfile :title_page="'Thay đổi mật khẩu'">
    <div class="flex justify-center">
      <div class="w-3/4">
        <form
          method="post"
          enctype="multipart/form-data"
          action=""
          name="myForm"
          class="p-2"
        >
          <slot></slot>
        </form>
      </div>
    </div>
  </LayoutProfile>
</template>
